module.exports = __webpack_public_path__ + "img/quality-work-plan.7e24cd79.png";